module.exports = __webpack_public_path__ + "img/ruler-combined.70ef4ede.svg";